export default "__VITE_ASSET__DxPYWJpn__"